import * as React from 'react';
import { Loader, LoaderSize, LoaderTheme } from '../Loader/Loader';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

type ProjectLeftPanelProps = {
    hasData: boolean;
    children: ReactChildrenGeneralType;
    noMinWidth?: boolean;
}

function ProjectLeftPanel({ hasData, children, noMinWidth }: ProjectLeftPanelProps) {
    return (
        <div className={`ProjectLeftPanel ${noMinWidth && 'no-min-width'}`}>
            <div className="ProjectLeftPanel__content">
                {hasData ? children :
                    <Loader theme={LoaderTheme.Light} size={LoaderSize.Medium} center={true} />}
            </div>
        </div>
    );
}

export default ProjectLeftPanel;
